import { Component } from 'react';
import {  isRtl,
          hasTreeActivationBanner,
          hasExpiringProUpsell, } from '../../library/constants';
import { doWhenReady, getWidthOfText, isMobilePhone } from '../../library/calc';

import './index.css';

/*
https://www.cronj.com/blog/export-htmlcss-pdf-using-javascript/
https://stackoverflow.com/questions/23681325/convert-canvas-to-pdf
https://konvajs.org/docs/data_and_serialization/Stage_Data_URL.html
http://pdfmake.org/playground.html
https://stackoverflow.com/questions/34242155/how-to-crop-canvas-todataurl
http://localhost:3000/60?import=true
 */


class Base extends Component {


  scroll = 0;
  imgHeight = 0;
  differencePrintCanvasWidth = 0;

  renderButtonIsEnabled = false;
  renderCompleted = false;
  inProcess = false;
  minMaxSetted = false;
  verySmallTree = false;
  numRowsInTree = 8;
  lastFurthestRightNodeBorderWidth = 3;

  checkedBoxArray = ['legend', 'bw', 'photos', 'pagenumber']

  printTreeCheckboxGroupDefaultWidth = 326;
  printTreeCheckboxLabelLeft = 306;
  numPreviewPanels = 3;

  state = {
    page: 1,
    maxPages: 0,
    minPages: 0,
    isPreviewRender: true,

    // pageSize: 'legal'
    // pageSize: 'letter',
    pageSize: 'letter',

    legend: true,
    bw: false,
    //  bw: true,
    pagenumber: true,
    photos: true,
    // photos: false,


  }

  constructor(props){
    super(props);

    /*

    widthArr:  [
      {
        "label": "Show legend",
        "width": 80.951171875
      },
      {
        "label": "Black and white",
        "width": 98.0546875
      },
      {
        "label": "Show photos",
        "width": 80.9443359375
      },
      {
        "label": "Show page numbers",
        "width": 128.4130859375
      }
    ]

     */

    this.checkBoxOptions = [
      { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show legend', 'Print tree options', null):'Show legend'), value: 'legend', width: 80.951171875},
      { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Black and white', 'Print tree options', null):'Black and white'), value: 'bw' , width: 98.0546875},
      { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show photos', 'Print tree options', null):'Show photos'), value: 'photos', width:  80.9443359375},
      { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show page numbers', 'Print tree options', null):'Show page numbers'), value: 'pagenumber', width: 128.4130859375 },
    ];

    // this.checkBoxOptions = [
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show legend', 'Print tree options', null):'Показывать обозначения'), value: 'legend', width: 80.951171875},
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Black and white', 'Print tree options', null):'Чёрно-белая печать'), value: 'bw' , width: 98.0546875},
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show photos', 'Print tree options', null):'Показывать фотографии'), value: 'photos', width:  80.9443359375},
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show page numbers', 'Print tree options', null):'Показывать номера страниц'), value: 'pagenumber', width: 128.4130859375 },
    // ];

    // this.checkBoxOptions = [
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show legend', 'Print tree options', null):'הצג כותרת'), value: 'legend', width: 80.951171875},
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Black and white', 'Print tree options', null):'שחור-לבן'), value: 'bw' , width: 98.0546875},
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show photos', 'Print tree options', null):'הצג תמונות'), value: 'photos', width:  80.9443359375},
    //   { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Show page numbers', 'Print tree options', null):'הצג מספרי עמודים'), value: 'pagenumber', width: 128.4130859375 },
    // ];

    this.checkBoxOptions = this.checkBoxOptions.map((option)=>{
      const realWidth = getWidthOfText({txt: option.label, fontname: 'Arial', fontsize: '14px'});
      const differenceWidth = realWidth - option.width;
      return { ...option, realWidth, differenceWidth};
    });

    const differceWidthRow_1 = this.checkBoxOptions[0].differenceWidth + this.checkBoxOptions[1].differenceWidth;
    const differceWidthRow_2 = this.checkBoxOptions[2].differenceWidth + this.checkBoxOptions[3].differenceWidth;

    this.moreCheckboxGroupWidth = ( differceWidthRow_1 > differceWidthRow_2 ? differceWidthRow_1: differceWidthRow_1);
    // this.printTreeCheckboxLabelLeft -= this.moreCheckboxGroupWidth;

    // this.moreModalWidth = this.moreCheckboxGroupWidth/3;
    // this.modalWidth += this.moreModalWidth;

    this.lowerPrintRes = this.props.lowerPrintRes;

    this.reducedCanvasTreeBy = 6.6; // printTreeResolution
    // portion = 3.8; // printTreeResolution Tweak
    this.portion = ( this.lowerPrintRes ? 2.4: 3.8); ; // printTreeResolution SuperTweak old: 3.8
    this.printTreeCanvasHeight = ( this.lowerPrintRes ? 2600: 1600);  // printTreeResolution SuperTweak old: 1600
    // pageHeight = 900; // printTreeResolution
    this.pageHeight = ( this.lowerPrintRes ? 800: 900); // printTreeResolution SuperTweak old: 900

    this.modalWidth = 718.6959635416666; // printTreeResolution 800

    const common = {
      // minPdFWidth: 950, // printTreeResolution Tweak 575, 675
      minPdFWidth: ( this.lowerPrintRes ? 575: 950), // printTreeResolution SuperTweak old: 950
      maxPdFHeight: 0,
      defaultPdFHeight: 164,
    }

    this.pageSizesDim = {
      'letter': {   // 8.5 x 11
        pdFLandscapeRatio: 1.3653061224489795, // printTreeResolution Tweak 1.294
        pdfPrintWidth: 715,
        ...common,
      },
      'legal': {   // 8.5 x 14
        pdFLandscapeRatio: 1.74705882,
        // pdFLandscapeRatio: 1.6,
        pdfPrintWidth: 930,
        ...common,
      },
      'tabloid': {  // 11 x 17
        pdFLandscapeRatio: 1.5454545454545454,
        pdfPrintWidth: 1105,
        ...common,
      },
      'a4': {
        pdFLandscapeRatio: 1.48,  // printTreeResolution Tweak 1.3253061224489795
        pdfPrintWidth: 760,
        ...common,
      },
    }

  }


  componentDidMount(){

    // const generations = this.props.numOfGenerations;

    if( isMobilePhone() ){
      if( hasTreeActivationBanner || hasExpiringProUpsell ){
        if( document.getElementById("expiring_pro_upsell")) document.getElementById("expiring_pro_upsell").style.display = 'none';
        if(document.getElementById("tree_activation_banner")) document.getElementById("tree_activation_banner").style.display = 'none';
      }
    }

    const whenPrintStageReady = () => {
      return typeof(this.printStage) !== 'undefined' &&
        document.getElementById('imgCanvasContainer') &&
        document.getElementById('croppedContainer');
    }

    const ready = () => {

      const {
        bottomEdgeOfTree,
        rightEdgeOfTree
      } = this.props.getEdgeOfTree();

      const scalePrintCanvas = this.props.scalePrintCanvas;

      this.bottomEdgeOfTree = bottomEdgeOfTree;
      this.rightEdgeOfTree = rightEdgeOfTree;

      this.differencePrintCanvasHeight = this.printTreeCanvasHeight - bottomEdgeOfTree;
      this.printCanvasWidth = ( rightEdgeOfTree * scalePrintCanvas );

      // const scalePrintCanvas = this.props.scalePrintCanvas;  // printTreeResolution SuperTweak

      const nodeRow = {
        7: 342,
        6: 290,
        5: 238,
        4: 186,
        3: 134,
      }

      if( bottomEdgeOfTree <= nodeRow[7] ) { this.numRowsInTree = 7; this.reducedCanvasTreeBy = 5.5; }
      if( bottomEdgeOfTree <= nodeRow[6] ) { this.numRowsInTree = 6; this.reducedCanvasTreeBy = 4.32; }
      if( bottomEdgeOfTree <= nodeRow[5] ) { this.numRowsInTree = 5; this.reducedCanvasTreeBy = 3.6; }
      if( bottomEdgeOfTree <= nodeRow[4] ) { this.numRowsInTree = 4; this.reducedCanvasTreeBy = 3; }
      if( bottomEdgeOfTree <= nodeRow[3] ) { this.numRowsInTree = 3; this.reducedCanvasTreeBy = 2.5; }

      this.setPageSizeDim();

      // console.log(`this.numRowsInTree: `, this.numRowsInTree);
      // console.log(`this.bottomEdgeOfTree: `, this.bottomEdgeOfTree);
      // console.log(`this.rightEdgeOfTree: `, this.rightEdgeOfTree);
      // console.log(`this.maxPdFHeight: `, this.maxPdFHeight);
      // console.log(`this.realPDFBottom: `, this.realPDFBottom);
      // console.log(`scalePrintCanvas: `, scalePrintCanvas);
      // console.log(`this.minPrintWidth: `, this.minPrintWidth);
      // console.log(`this.printCanvasWidth: `, this.printCanvasWidth); // this.printCanvasWidth = ( rightEdgeOfTree * scalePrintCanvas );
      // console.log(`diff from minimum: `, this.minPrintWidth - this.printCanvasWidth );

      const minForSegmentation = this.minPdFWidth * this.reducedCanvasTreeBy;
      // console.log(`minForSegmentation: `, minForSegmentation);
      const difFromSegmentation = minForSegmentation - this.printCanvasWidth;
      const maxDifFromSegmentation = 600;
      // console.log(`difFromSegmentation: `, difFromSegmentation);

      let maxPages = this.findMaxPages();
      let minPages = this.findMinPages();

      if( this.printCanvasWidth < minForSegmentation && this.numRowsInTree <= 5){
        // console.log('---- is below minForSegmentation.');
        this.printCanvasWidth = minForSegmentation - (difFromSegmentation > maxDifFromSegmentation ? maxDifFromSegmentation: difFromSegmentation);
        this.actualTreeWidth = rightEdgeOfTree * scalePrintCanvas;
        this.differencePrintCanvasWidth = this.printCanvasWidth - this.actualTreeWidth;
        // console.log(`differencePrintCanvasWidth: `, this.differencePrintCanvasWidth);
        this.verySmallTree = true;
        this.differencePrintCanvasHeight = this.printTreeCanvasHeight - this.bottomEdgeOfTree;
        this.portion = 3.55; // printTreeResolution Tweak 4
        maxPages = 1;
        minPages = 1;
      }

      this.setMaxPages({maxPages, minPages});
      this.minMaxSetted = true;
      this.inProcess = true;

      // this.buildFrontLegend();
      // this.buildBackLegend();
      if( !this.isPrintFlipCardMobile ) {
        setTimeout(() => {
          this.printInSections({isPreview: true});
        }, 1500);
      } else {
        setTimeout(() => {
          this.printInSections({isPreview: true});
        }, 500);
      }


      if( isRtl){
        this.returnScrollToBeginning();
      }

      // if(document.querySelector(`.ant-modal-footer`)){
      //   const antModalFooter = document.querySelector(`.ant-modal-footer`);
      //   antModalFooter.style.setProperty("margin-top", '38px');
      // }


      /*
        setTimeout(() => {

          document.getElementById("printStageWrapper").scrollBy({
            top: 180,
            left: 0,
            behavior: 'smooth',
          });
        }, 400);
      */
    }

    doWhenReady({argument: '', condition: whenPrintStageReady, callback: ready, attempts: {ongoing:0, end: 99999999}, fromWhere: 'whenPrintStageReady'})

  }

  setMinMaxPages(){

  }

  setPageSizeDim(){
    const scalePrintCanvas = this.props.scalePrintCanvas;
    this.realPDFBottom = ((this.bottomEdgeOfTree * scalePrintCanvas) / this.reducedCanvasTreeBy);
    const minPDFBottom = this.pageSizesDim[this.state.pageSize]['defaultPdFHeight'] + 70; // printTreeResolution Tweak 35
    this.maxPdFHeight = this.pageSizesDim[this.state.pageSize]['maxPdFHeight'] = ( this.realPDFBottom < minPDFBottom ? minPDFBottom : this.realPDFBottom) ;
    this.pdFLandscapeRatio = this.pageSizesDim[this.state.pageSize]['pdFLandscapeRatio'];
    this.pdfPrintWidth = this.pageSizesDim[this.state.pageSize]['pdfPrintWidth'];
    this.minPdFWidth = this.pageSizesDim[this.state.pageSize]['minPdFWidth'];
    this.minPrintWidth = this.printTreeCanvasHeight * this.pdFLandscapeRatio;

  }

  renderStart({isPreview}){
    this.totalNodesInTree = 0
    this.renderCompleted = false;
    let pdfButtonStr = 'Create PDF';
    pdfButtonStr = ( typeof(window.trl) !== 'undefined' ? window.trl(pdfButtonStr, 'Print tree button', null):pdfButtonStr);
    document.getElementById('createPDFButton').innerHTML = pdfButtonStr;
    this.setState({isPreviewRender: ( typeof(isPreview) !== 'undefined' ? true : false)})
    this.renderButtonEnabled(false);
  }

  renderComplete(){
    this.renderCompleted = true;
    this.showPrintTreeProgressIndicator(false);
    this.renderButtonEnabled(true);
    let downloadnButtonStr = 'Download';
    downloadnButtonStr = ( typeof(window.trl) !== 'undefined' ? window.trl(downloadnButtonStr, 'Print tree button', null):downloadnButtonStr);
    document.getElementById('createPDFButton').innerHTML = downloadnButtonStr;
    this.createPDF();
  }

  findMaxPages(){
    let maxPages = 0;
    for( var page = 1; page < 1000; page++){

      const imgWidth = (this.printCanvasWidth / this.reducedCanvasTreeBy) / page;
      const pdfImgHeight =  imgWidth / this.pdFLandscapeRatio;
      if( pdfImgHeight > this.maxPdFHeight){
        maxPages = page;
      } else {
        break;
      }
    }
    return maxPages;
  }

  findMinPages(){
    let minPages = 0;
    for( var page = 500; page > 0; page--){
      const imgWidth = (this.printCanvasWidth / this.reducedCanvasTreeBy) / page;
      if(imgWidth > this.minPdFWidth){
        break;
      } else {
        minPages = page;
      }
    }
    return minPages;
  }

  // setPageSize({ pageSize }){

  //   this.setState({
  //     pageSize
  //   })

  //   this.returnScrollToBeginning();

  //   this.showRenderLabel();

  //   this.setPageSizeDim();

  //   let maxPages = this.findMaxPages();
  //   let minPages = this.findMinPages();

  //   this.setMaxPages({maxPages, minPages});

  //   setTimeout(() => {

  //     this.printInSections({isPreview: true});

  //   }, 600);

  // }

  setPageSize({ pageSize }){

    this.setState({
      pageSize
    })

    this.returnScrollToBeginning();

    this.showRenderLabel();

    setTimeout(() => {

      this.setPageSizeDim();

      let maxPages = this.findMaxPages();
      let minPages = this.findMinPages();

      this.setMaxPages({maxPages, minPages});

      this.printInSections({isPreview: true});

    }, 600);

  }

  restartAfterCheckboxChangedOptions(){

    this.returnScrollToBeginning();

    this.showRenderLabel();

    this.printInSections({isPreview: true});

  }

  setCheckboxes(checkedValues){

    const missingChecked =  this.checkedBoxArray.filter(function(key) {
      return !checkedValues.includes(key);
    })

    let checkedObj = {};
    checkedValues.forEach((value)=>{
      checkedObj[value] = true;
    });

    this.setState(checkedObj);

    let missingCheckedObj = {};
    missingChecked.forEach((value)=>{
      missingCheckedObj[value] = false;
    });

    const formEntries = {...checkedObj, ...missingCheckedObj};

    const changedCheckedBox = this.checkedBoxArray.map((key)=>{
      let changedKey = null;
      if( this.state[key] !== formEntries[key] ) changedKey = key
      return changedKey;
    }).filter(Boolean);

    this.setState(missingCheckedObj);

    if( (changedCheckedBox[0] !== 'pagenumber' && changedCheckedBox[0] !== 'legend' && !this.state.isPreviewRender) ||
         changedCheckedBox[0] === 'bw'
    ){
      this.restartAfterCheckboxChangedOptions();
    }

  }

  setMaxPages({maxPages, minPages}){

    this.setState({
      maxPages: ( maxPages < minPages ? minPages: maxPages),
      minPages,
      // page: maxPages,
      page: minPages,
    })
  }

  shouldUpdate = true;
  shouldComponentUpdate(nextProps, nextState) {
    return this.shouldUpdate;
  }

  showRenderLabel(){
    if( this.debug) return;


    if( this.state.isPreviewRender ){
      let previewTextStr = 'Preview of first three pages only';
      if( this.isPrintFlipCardMobile ) previewTextStr = 'Preview';
      previewTextStr = ( typeof(window.trl) !== 'undefined' ? window.trl(previewTextStr, 'Tree legend', null):previewTextStr);
      document.getElementById(`labelRendered`).innerHTML = `${previewTextStr}. `;
      document.getElementById(`numberRendered`).innerHTML = "";
    } else {
      let renderingTextStr = 'Rendering';
      renderingTextStr = ( typeof(window.trl) !== 'undefined' ? window.trl(renderingTextStr, 'Tree legend', null):renderingTextStr);
      document.getElementById(`labelRendered`).innerHTML = `${renderingTextStr}: `;
      if(this.pageCurrent <= this.state.page) document.getElementById(`numberRendered`).innerHTML = `${this.pageCurrent}/${this.state.page}`;
    }
  }


  renderButtonEnabled(how){
    this.renderButtonIsEnabled = how;
    if(how){
      document.getElementById('createPDFButton').style.opacity = 1;
    } else{
      document.getElementById('createPDFButton').style.opacity = .5;
    }
  }


  showPrintTreeProgressIndicator(how){
    let display = 'none';
    if (how) display = 'block';
    if(document.getElementById('printTreeProgressIndicator')) document.getElementById('printTreeProgressIndicator').style.display = display;
  }

  scrollCroppedContainer(){
    const everyN = 1;
    const pagesMoved = 1;
    if( this.pageCurrent > (this.numPreviewPanels + 1) &&
        this.pageCurrent % everyN === 0 &&
        document.getElementById("croppedContainerWrapper")
      ) {
      document.getElementById("croppedContainerWrapper").scrollBy({
        top: 0,
        left: this.imgWidth * pagesMoved,
        behavior: 'smooth',
      });
    }
  }

  printInSections({isPreview}){

    if( isRtl){
      this.returnScrollToBeginning();
    }

    this.renderStart({isPreview});

    this.eachSegmentWidth = this.printCanvasWidth / this.state.page;

    this.pdfContentArray = [];
    this.docDefinition = {};

    this.setCroppedWidthHeight();
    this.setCroppedContainerWrapperWidth({isPreview});
    this.removeCroppedImgs();

    this.setCroppedContainerWrapperHeightPadding();
    this.renderCanvasTreeInSections({isPreview});
    // this.renderOnePage(17) // printTreeResolution SuperTweak
  }


  returnScrollToBeginning(){
    document.getElementById("croppedContainerWrapper").scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

  }

  onPageNumberChange = (value) => {

    this.returnScrollToBeginning();

    this.showRenderLabel();

    this.setState({
      page: value,
    });

    setTimeout(() => {
      this.printInSections({isPreview: true});
    }, 600);
  }

  setPrintStage({stage}){

    this.printStage = stage;
    const scalePrintCanvas = this.props.scalePrintCanvas;
    this.printStage.current.scale({ x: scalePrintCanvas, y: scalePrintCanvas });

    this.printStage.current.position({
      x: 0,
      y: 0,
    });

  }

  changeModalElementsWidth(){

    /*
      *
      *
      *
          Checkbox group
      *
      *
      *
     */

   if( !this.isPrintFlipCardMobile ) {
    const printTreeCheckboxWrapper = document.getElementById('printTreeCheckboxWrapper');
    printTreeCheckboxWrapper.style.right = `${this.printTreeCheckboxGroupDefaultWidth + this.moreCheckboxGroupWidth}px`;
    const checkboxGroup = document.getElementById('printTreeCheckboxGroup')
    checkboxGroup.style.width =`${ this.printTreeCheckboxGroupDefaultWidth + this.moreCheckboxGroupWidth }px`;
   }

    // const evenOutCheckboxesForAlignment = () => {

      // const printTreeCheckboxLabels = document.querySelectorAll('#printTreeCheckboxGroup .ant-checkbox-group-item');
      // const isOdd = (num) => { return num % 2;};

      // let minWidth = 0;
      // for (let idx = 0; idx < printTreeCheckboxLabels.length; ++idx) {
      //   if(!isOdd(idx)){
      //     const printTreeCheckboxLabelWidth = parseInt(printTreeCheckboxLabels[idx].getBoundingClientRect().width, 10);
      //     // console.log(`printTreeCheckboxLabelWidth: `, printTreeCheckboxLabelWidth);
      //     if( printTreeCheckboxLabelWidth > minWidth ) minWidth = printTreeCheckboxLabelWidth;
      //   }
      // }

      // if( minWidth > 0 ){
      //   for (let idx = 0; idx < printTreeCheckboxLabels.length; ++idx) {
      //     if(!isOdd(idx)){
      //       if( isRtl ) minWidth += 8; // add left margin
      //       printTreeCheckboxLabels[idx].style.minWidth = `${minWidth}px`;
      //       console.log(`minWidth: `, minWidth);
      //     }
      //   }
      // }

    // }

    // evenOutCheckboxesForAlignment();

  }

}

export default Base;

